import type { FC } from "react";
import React from "react";

import { Counter } from "../../../../Counter/Counter";

import type { CounterPropsRegularSize } from "../../../../Counter/Counter";

export const TAB_COUNTER_TEST_ID = "tab-counter-test-id";

export interface ITabCounterProps
    extends Pick<CounterPropsRegularSize, "quantity"> {}

interface ITabCounterExtendedProps extends ITabCounterProps {
    size?: CounterPropsRegularSize["size"];
}

export const TabCounter: FC<ITabCounterProps> = (props) => {
    const size = (props as ITabCounterExtendedProps).size || "16";
    return (
        <Counter
            {...props}
            size={size}
            stroke
            data-tsid={TAB_COUNTER_TEST_ID}
        />
    );
};

TabCounter.displayName = "Tab.Counter";

export default TabCounter;
